import styled from 'styled-components'

export const Footer = styled.footer.attrs({
  className: 'tabs-footer'
})`
  margin-left: auto;
  display: flex;

  width: 6rem;
`

export const Foot = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 0.875rem;

  cursor: pointer;

  width: 1.7rem;
  height: 1.7rem;

  border: 1px solid var(--tabs-selected-color);
  border-radius: 99px;
  color: var(--tabs-selected-color);

  & + & {
    margin-left: 0.3rem;
  }

  &.disabled {
    border: 0;

    pointer-events: none;
    cursor: initial;

    span {
      color: var(--tabs-disabled-color);
    }
  }

  &.selected {
    border: 0;
    background: var(--tabs-selected-color);

    span {
      color: white;
    }
  }
`
